import { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";

import { useLocation } from 'react-router-dom';

const stripeKey = process.env.REACT_APP_STRIPE_KEY;

const stripePromise = loadStripe(stripeKey);

export default function Checkout() {
  const [clientSecret, setClientSecret] = useState(null);


      // Call your backend to create Checkout Session
    //
    const location = useLocation();
    const cart = location.state;
	//console.debug(cart);

    //const urlParams = new URLSearchParams(window.location.search);
    //const shipping = urlParams.get("shipping");
    //const qty =  urlParams.get("qty");
    //
    const shipping = cart.shipping;
    const qty = cart.qty;


  useEffect(() => {
	//console.log(`got qty: ${qty} got ship: ${shipping}`);

	fetch("/create.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quantity: qty, shipping: shipping }),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
  }, [qty, shipping]);

  if (!clientSecret) return <p>Loading checkout?</p>;

  return (
  <>
  	<br />
    <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  </>
  );
}
